import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { AuthProjectsRedirectGuard } from './guards/auth.project.guard';
import { CreateProjectComponent } from './pages/create-project/create-project.component';
import { ProjectDetailsComponent } from './pages/project-details/project-details.component';
import { ProjectsListComponent } from './pages/projects-list/projects-list.component';
import { PublicProjetComponent } from './pages/public-project/public-project.component';
import { ProjectsComponent } from './projects.component';

const projectsRoutes: Routes = [
    {
        path: '',
        data: {
            title: 'navMenu.projectsTitle',
            showBackButton: false,
        },
        component: ProjectsComponent,
        children: [
            { path: '', component: ProjectsListComponent, canActivate: [AuthGuard] },
            { path: 'create', component: CreateProjectComponent, canActivate: [AuthGuard] },
            { path: 'public/:id', component: PublicProjetComponent, canActivate: [AuthProjectsRedirectGuard] },
            {
                path: ':id',
                data: {
                    title: 'navMenu.projectsTitle',
                    showBackButton: true,
                    defaultBack: 'projects',
                },
                component: ProjectDetailsComponent,
                canActivate: [AuthProjectsRedirectGuard],
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(projectsRoutes)],
    exports: [RouterModule],
})
export class ProjectsRoutingModule {}
